export default {
  new_menu: {
    // 第一层菜单
    main: {
      console: '工作台',
      charging_pile_station: '站桩管理',
      transaction: '交易管理',
      application: '审核工单',
      user: '用户管理',
      discount: '营销管理',
      operation: 'APP设置',
      evcs: '互联互通',
      report: '报表统计',
      system: '系统管理',
      service_provider: '运营结算',
      shop: '商城管理',
      parking: '车位/停车',
      notification_center: '通知中心'
    },
    // 工作台
    consoles: {
      dashboard: '工作面板'
    },
    // 站桩管理
    charging_pile_stations: {
      charging_station: '充电站查询',
      charging_station_desc: '地图',
      charger: '充电枪查询',
      charge_point: '充电桩查询',
      charging_pile_desc: '固件、二维码',
      parking_lock: '车位地锁',
      nvr_channel: '监控摄像头',
      billing_rule: '充电费率',
      billing_rule_timer: '费率定时器',
      billing_rule_temperature_timer: '高温费率定时器',
      station_comment: '评论管理',
      station_comment_reply: '评论回复',
      activity: '用户访问日志',
      ev_charging_stations: '共享站查询',
      ev_charging_stations_desc: '共享桩、充电App',
      parking_reliefs: '停车减免规则',
      magcard_swipe_records: '刷卡启动记录',
      vin_records: 'VIN启动记录',
      inserting_gun_start_records: '即插即充启动记录',
      start_appointments: '启动预约',
      idle_fees: '占位费规则',
      idle_fee_bills: '占位费账单',
      alarm: '告警管理',
      equipment_productions: '设备出厂管理',
      equipment_dispatch: '设备出库管理',
      materials: '资料管理'
    },
    // 交易记录
    transactions: {
      order: '充电订单',
      order_desc: '订单统计',
      top_up: '用户充值',
      withdraw: '用户提现',
      group_topup_withdraw: '集团充值/提现',
      admin_withdraw: '管理员提现',
      point: '积分消费',
      charging_card_consumption: '充电卡消费',
      service_provider_transaction_records: '运营商结算流水'
    },
    // 审核工单
    applications: {
      invoice: '开票记录',
      refund: '订单退款申请',
      group_application: '集团用户申请',
      service_provider_withdraw: '运营商提现申请',
      work_orders: '工单管理'
    },
    // 通知中心
    notifications: {
      notification_subscriptions: '订阅管理',
      alarm_notification_rules: '告警通知规则',
      subscription_trigger_records: '订阅触发记录'
    },
    // 用户管理
    users: {
      user: '用户查询',
      membership: '会员管理',
      car: '车辆认证',
      user_desc: '统计/概览、充值统计、订单统计、发送信息/优惠',
      magcard: '用户磁卡',
      magcard_desc: '磁卡信息、刷卡记录',
      message: '消息通知',
      feedback: '意见反馈',
      virtual_user: '虚拟用户'
    },
    // 优惠管理
    discounts: {
      group: '集团优惠',
      coupon: '优惠券',
      charging_package: '充电包',
      charging_card: '充电卡',
      gift_card: '礼品卡',
      gift_card_desc: '扫码领优惠券',
      settlement_discount: '渠道活动'
    },
    shops: {
      products: '商品管理',
      product_orders: '商品订单',
      pickup_locations: '提货点',
      product_return_applications: '退款申请'
    },
    // 运营管理
    operations: {
      operation_activity: '用户邀请活动',
      discount_activity: '活动优惠奖励',
      app_pages: 'App跳转页',
      task_definition: '积分任务',
      posts: '文章管理',
      advertisements: '广告管理'
    },
    // 停车
    parkings: {
      parking_relief_records: '停车减免记录',
      parking_relief_codes: '减免二维码'
    },
    service_providers: {
      charge_channel: '充电渠道管理',
      service_provider: '运营商',
      service_provider_settlement_rule: '订单结算规则',
      discount_settlement_rule: '优惠结算规则',
      charging_package_settlement_rule: '充电包结算规则',
      idle_fee_settlement_rule: '占位结算规则',
      ev_charging_station_settlements: '充电站结算',
      bank_accounts: '银行账户管理',
      ev_charging_station_daily_settlements: '充电站日结算'
    },
    // 互联互通
    evcs: {
      operator: '第三方平台',
      station: '第三方电站',
      connector: '第三方设备接口',
      order: '第三方设备订单',
      charge_record: '第三方设备充电',
      ecmp_order: '我方设备订单',
      evcs_notification_order: '政府平台推送订单',
      evcs_trace: '接口调用日志'
    },
    // 报表统计
    reports: {
      order_statistics: '订单统计',
      top_up_statistics: '充值统计',
      user_overview: '用户统计',
      my: '我的报表'
    },
    // 系统管理
    systems: {
      admin: '管理员',
      role: '角色管理',
      charging_pile_setting: '电桩设置',
      vin_blacklists: 'VIN黑名单',
      system_setting: '系统配置',
      tag: '标签管理',
      model_version_log_audits: '数据版本日志',
      third_party_service_traces: '第三方服务日志'
    },
    // 部分菜单的关键词，主要是为了强化搜索
    keywords: {
      report: '报表/统计',
      station: '充电站',
      discount: '优惠',
      interconnectivity: '互联互通',
      setting: '设置/配置'
    }
  }
}
